import { ArrowUpRight, Wine as WineIcon } from "lucide-react";
import { Chapter, Reveal } from "./Reveal";
import { IMAGES, VINOPOLIS_URL } from "@/data/content";

const Events = () => (
  <section id="eventi" data-testid="eventi-section" className="relative py-24 sm:py-36 bg-[#141210] overflow-hidden">
    <div className="absolute inset-0">
      <img
        src={IMAGES.events}
        alt=""
        loading="lazy"
        className="w-full h-full object-cover opacity-[0.14]"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#141210] via-[#141210]/60 to-[#141210]" />
    </div>

    <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Chapter number="05" title="Gli Eventi" center />
      <Reveal delay={0.1}>
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full border border-[#C5A059]/40 text-[#C5A059] mb-8">
          <WineIcon size={26} strokeWidth={1.5} />
        </span>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-[#F7F4EE] tracking-tight">
          4 Vini <span className="italic text-[#C5A059]">&amp;</span> Una Bistecca
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 text-base sm:text-lg text-[#C5BCAD] leading-relaxed max-w-2xl mx-auto">
          Le nostre serate di degustazione alla cieca: quattro calici bendati, un
          taglio d'autore al centro del tavolo e una sala che gioca a indovinare.
          Posti limitati, atmosfera garantita.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <a
          data-testid="vinopolis-cta-button"
          href={VINOPOLIS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[#C5A059] text-[#0D0C0B] text-sm uppercase tracking-[0.2em] hover:bg-[#F7F4EE] transition-colors duration-300"
        >
          Scopri le serate su Vinopolis
          <ArrowUpRight size={18} />
        </a>
        <p className="mt-4 text-xs text-[#C5BCAD]/60">
          L'app degli eventi di casa Tartarino — calendario e prenotazioni.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Events;
